import React from 'react';
import { slate1 } from '@engage/colors';

const ErrorIcon: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  title,
  color,
  ...props
}) => (
  <svg
    width={28}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 28 28"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <path
      d="M15.362 5.148a1.586 1.586 0 0 0-2.724 0L3.595 20.192c-.15.25-.23.538-.23.83 0 .886.713 1.604 1.592 1.604h18.086c.29 0 .575-.08.824-.232a1.61 1.61 0 0 0 .538-2.202L15.362 5.148zm1.167-.712l9.043 15.045a2.99 2.99 0 0 1-.998 4.089c-.462.281-.991.43-1.531.43H4.957A2.967 2.967 0 0 1 2 21.023c0-.544.148-1.077.427-1.542L11.47 4.436a2.945 2.945 0 0 1 5.06 0zM13.317 18.16c0-.38.306-.687.683-.687.377 0 .682.307.682.687v.801c0 .38-.305.687-.682.687a.685.685 0 0 1-.683-.687v-.801zm0-8.017c0-.379.306-.687.683-.687.377 0 .682.308.682.687v5.154c0 .38-.305.687-.682.687a.685.685 0 0 1-.683-.687v-5.154z"
      fill={color ?? slate1}
      fillRule="nonzero"
    />
  </svg>
);

export type Props = React.SVGProps<SVGSVGElement> & { title?: string };

export default ErrorIcon;
